"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonTypes = _interopRequireDefault(require("../../common/message-popup/button-types"));

var _messagePopup = _interopRequireDefault(require("../../common/message-popup/message-popup"));

var _videoTypes = _interopRequireDefault(require("../video-types"));

const ConfirmDeleteVideoPopup = props => {
  const {
    onClose,
    onConfirm,
    videoType,
    videoName,
    className,
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement(_messagePopup.default, {
    className: (0, _classnames.default)('confirm-delete-video-popup', className),
    onClose: onClose,
    title: "Delete ".concat(videoType, "?"),
    hasClose: false,
    buttons: [{
      value: 'cancel',
      name: 'Cancel, keep it',
      onClick: onClose,
      type: _buttonTypes.default.WHITE
    }, {
      value: 'delete',
      name: 'Yes, delete it',
      onClick: onConfirm,
      type: _buttonTypes.default.RED
    }]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "message-popup__description"
  }, /*#__PURE__*/_react.default.createElement("div", null, "Deleting this video cannot be undone."), /*#__PURE__*/_react.default.createElement("div", null, "Are you sure you want to delete the ".concat(videoType, " \"").concat(videoName, "\"?")), children));
};

ConfirmDeleteVideoPopup.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onConfirm: _propTypes.default.func.isRequired,
  videoType: _propTypes.default.oneOf(Object.values(_videoTypes.default)).isRequired,
  videoName: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
ConfirmDeleteVideoPopup.defaultProps = {
  className: '',
  children: null
};
var _default = ConfirmDeleteVideoPopup;
exports.default = _default;